import { useContext } from 'react';
import { AuthContext } from '../components/AuthContext';

export const useAuth = () => {
  const context = useContext(AuthContext);
  return { ...context };
};
